export const PAINT_PERFORMANCE_INDEXES = ["A0", "A1", "A2", "B1", "B2", "C1", "C2", "Unknown"] as const;

export type PaintPerformanceIndex = (typeof PAINT_PERFORMANCE_INDEXES)[number];

export const HEMPEL_TIER_OPTIONS = [0, 1, 2, 3, 4, 5] as const;

export interface AdminPaintSchemeRecord {
  VENDOR: string;
  PAINT: string;
  PERFORMANCE_INDEX: PaintPerformanceIndex;
  HEMPEL_TIER: number;
  COMMENTS: string | null;
  UPLOAD_TS: string;
}

export interface AdminPaintSchemeApiRow {
  VENDOR?: string | null;
  PAINT?: string | null;
  PERFORMANCE_INDEX?: string | null;
  HEMPEL_TIER?: number | string | null;
  COMMENTS?: string | null;
  UPLOAD_TS?: string | null;
}

export type AdminPaintSchemeGridRow = Omit<AdminPaintSchemeRecord, "HEMPEL_TIER"> & {
  gridRowId: string;
  HEMPEL_TIER: number | string;
};

export interface AdminPaintSchemeListResponse {
  rows: AdminPaintSchemeApiRow[];
}

export interface AdminPaintSchemeFormValue {
  vendor: string;
  paint: string;
  performanceIndex: PaintPerformanceIndex;
  hempelTier: string;
  comments: string;
}

export const EMPTY_ADMIN_PAINT_SCHEME_FORM: AdminPaintSchemeFormValue = {
  vendor: "",
  paint: "",
  performanceIndex: "Unknown",
  hempelTier: "0",
  comments: "",
};

export interface PerformanceIndexReference {
  index: PaintPerformanceIndex;
  description: string;
}

export const PERFORMANCE_INDEX_REFERENCE: PerformanceIndexReference[] = [
  { index: "A0", description: "Silicone + <1.5% expected speed loss" },
  { index: "A1", description: "<1.5%" },
  { index: "A2", description: "<2.5%" },
  { index: "B1", description: "<3.5%" },
  { index: "B2", description: "<4.5%" },
  { index: "C1", description: "≥5%" },
  { index: "C2", description: "≥5%" },
  { index: "Unknown", description: "No data" },
];
